import api from "api"

export const callingPlateform = () =>{
   return api.get(`api/authDashboard/calling-platform`);
}

export const slot_booking_audit = (agentId, date) =>{
   return api.get(`api/authDashboard/slot-booking-audit?agent=${agentId}&reportDate=${date}`);
}

export const coach_waba_count =(agentId, date) =>{
   return api.get(`api/authDashboard/coach-waba-counts?agent=${agentId}&reportDate=${date}`)
}

export const order_related = (agentId, date) =>{
   return api.get(`api/authDashboard/coach-order-stats?agent=${agentId}&reportDate=${date}`)
}